import { forEach, has } from 'lodash/fp';

// @ts-expect-error - Automatic, Please fix when editing this file
let logger = null;

export default {
  // @ts-expect-error - Automatic, Please fix when editing this file
  getLogger: () => logger,
  // @ts-expect-error - Automatic, Please fix when editing this file
  setLogger: (newLogger) => {
    forEach(
      (level) => {
        if (!has(level, newLogger)) {
          throw new Error('Logger does not have the required level');
        }
      },
      ['error', 'warn', 'info'],
    );

    logger = newLogger;
  },
};
